(() => {
  'use strict';
  const key = 'recently-viewed';
  const timestampKey = 'rg_recently_viewed_at_v1';
  const maxAge = 30 * 24 * 60 * 60 * 1000;
  function read() {
    try {
      const value = localStorage.getItem(key);
      if (!value) { localStorage.removeItem(timestampKey); return []; }
      const rawTimestamp = localStorage.getItem(timestampKey);
      const timestamp = Number(rawTimestamp);
      if (rawTimestamp && (!Number.isFinite(timestamp) || timestamp <= 0 || Date.now() - timestamp > maxAge)) {
        localStorage.removeItem(key);
        localStorage.removeItem(timestampKey);
        return [];
      }
      const handles = [...new Set(value.split(',').filter(handle => handle && handle !== 'undefined' && handle !== 'null' && /^[a-z0-9\u0080-\uFFFF_-]+$/i.test(handle)))].slice(0, 10);
      if (!handles.length) { localStorage.removeItem(key); localStorage.removeItem(timestampKey); return []; }
      if (value !== handles.join(',')) localStorage.setItem(key, handles.join(','));
      if (!rawTimestamp) localStorage.setItem(timestampKey, String(Date.now()));
      return handles;
    } catch (_) { return []; }
  }
  function add(handle) {
    if (!handle || !/^[a-z0-9\u0080-\uFFFF_-]+$/i.test(handle)) return;
    const handles = [handle, ...read().filter(value => value !== handle)].slice(0, 10);
    try { localStorage.setItem(key, handles.join(',')); localStorage.setItem(timestampKey, String(Date.now())); } catch (_) {}
  }
  window.RGRecentProducts = { read, add };
  if ('requestIdleCallback' in window) requestIdleCallback(read, { timeout: 3000 });
  else setTimeout(read, 1500);
})();
